{
  "name": "UserAuthentication",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "groupId",
          "type": "bytes32"
        },
        {
          "components": [
            {
              "internalType": "bytes32[]",
              "name": "userIds",
              "type": "bytes32[]"
            },
            {
              "internalType": "uint256",
              "name": "threshold",
              "type": "uint256"
            }
          ],
          "indexed": false,
          "internalType": "structMultiSigGroup",
          "name": "group",
          "type": "tuple"
        }
      ],
      "name": "MultiSigGroupCreated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "groupId",
          "type": "bytes32"
        }
      ],
      "name": "MultiSigGroupDeleted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "groupId",
          "type": "bytes32"
        },
        {
          "components": [
            {
              "internalType": "bytes32[]",
              "name": "userIds",
              "type": "bytes32[]"
            },
            {
              "internalType": "uint256",
              "name": "threshold",
              "type": "uint256"
            }
          ],
          "indexed": false,
          "internalType": "structMultiSigGroup",
          "name": "group",
          "type": "tuple"
        }
      ],
      "name": "MultiSigGroupUpdated",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "wallet",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bytes",
          "name": "multiSigInitData",
          "type": "bytes"
        }
      ],
      "name": "UserAuthenticationInitialized",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "ADMIN_ROLE",
      "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "INIT_HASH",
      "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "VERSION",
      "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "components": [
            { "internalType": "address", "name": "sender", "type": "address" },
            { "internalType": "uint256", "name": "nonce", "type": "uint256" },
            { "internalType": "bytes", "name": "initCode", "type": "bytes" },
            { "internalType": "bytes", "name": "callData", "type": "bytes" },
            {
              "internalType": "uint256",
              "name": "callGasLimit",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "verificationGasLimit",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "preVerificationGas",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "maxFeePerGas",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "maxPriorityFeePerGas",
              "type": "uint256"
            },
            {
              "internalType": "bytes",
              "name": "paymasterAndData",
              "type": "bytes"
            },
            { "internalType": "bytes", "name": "signature", "type": "bytes" }
          ],
          "internalType": "structUserOperation",
          "name": "userOp",
          "type": "tuple"
        },
        { "internalType": "bytes32", "name": "userOpHash", "type": "bytes32" },
        { "internalType": "bytes", "name": "", "type": "bytes" }
      ],
      "name": "authenticateUserOp",
      "outputs": [
        { "internalType": "uint256", "name": "sigTimeRange", "type": "uint256" }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "groupId", "type": "bytes32" },
        {
          "components": [
            {
              "internalType": "bytes32[]",
              "name": "userIds",
              "type": "bytes32[]"
            },
            {
              "internalType": "uint256",
              "name": "threshold",
              "type": "uint256"
            }
          ],
          "internalType": "structMultiSigGroup",
          "name": "group",
          "type": "tuple"
        }
      ],
      "name": "createMultiSigGroup",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "groupId", "type": "bytes32" }
      ],
      "name": "deleteMultiSigGroup",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "key", "type": "bytes32" }
      ],
      "name": "getState",
      "outputs": [
        { "internalType": "bytes", "name": "state", "type": "bytes" }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "key", "type": "bytes32" }
      ],
      "name": "getState32",
      "outputs": [
        { "internalType": "bytes32", "name": "state", "type": "bytes32" }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes", "name": "multiSigInitData", "type": "bytes" }
      ],
      "name": "init",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "address", "name": "", "type": "address" },
        { "internalType": "uint256", "name": "", "type": "uint256" },
        { "internalType": "bytes", "name": "", "type": "bytes" },
        { "internalType": "bytes", "name": "_signature", "type": "bytes" },
        { "internalType": "bytes32", "name": "_hash", "type": "bytes32" }
      ],
      "name": "isValidAction",
      "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "moduleId",
      "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes[]", "name": "calls", "type": "bytes[]" }
      ],
      "name": "multiCall",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes", "name": "signature", "type": "bytes" },
        { "internalType": "bytes32", "name": "userOpHash", "type": "bytes32" },
        { "internalType": "bytes32", "name": "userId", "type": "bytes32" }
      ],
      "name": "subValidateSignatureECDSA",
      "outputs": [
        { "internalType": "uint256", "name": "sigTimeRange", "type": "uint256" }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        { "internalType": "bytes32", "name": "groupId", "type": "bytes32" },
        {
          "components": [
            {
              "internalType": "bytes32[]",
              "name": "userIds",
              "type": "bytes32[]"
            },
            {
              "internalType": "uint256",
              "name": "threshold",
              "type": "uint256"
            }
          ],
          "internalType": "structMultiSigGroup",
          "name": "group",
          "type": "tuple"
        }
      ],
      "name": "updateMultiSigGroup",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "addresses": {
    "1": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "5": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "10": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "137": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "8453": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "36865": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "42161": "0xb3DeA1dd1d9aC323041850c0A15C578C883F3f6F",
    "421614": "0x81C464389b2ac51D39aD934732bd172c4126773b",
    "5000": "0x73dBAFFa2B1E93D4c824B70DE8CA8926b9F18339",
    "534352": "0xe6e015a9C1A06D348A94e964dA27CdC34CaF36E6"
  }
}
